import { extend, localize } from 'vee-validate';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

extend('phone_number', {
  validate: (v) => {
    if (!v) {
      return false;
    }
    const phoneObject = parsePhoneNumberFromString(v);
    if (!phoneObject) {
      return false;
    }
    return phoneObject.isValid();
  },
  message: 'Invalid Phone Number',
});

extend('australia_phone_number', {
  validate: (value) => {
    const regexRule = /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/;
    if (regexRule.test(value)) {
      return true;
    }

    return 'This {_field_} field must be a valid Australia phone number';
  },
});

extend('exist', {
  validate(value, args) {
    return args['names'].length == 0;
  },
  params: ['names'],
  message: 'This {_field_} exists',
});

extend('exist', {
  validate(value, args) {
    return args['names'].length == 0;
  },
  params: ['names'],
  message: 'This {_field_} exists',
});

extend('snake_case', {
  validate: (value) => {
    const regexRule = /^[a-z][a-z0-9_]*[a-z0-9]$/;
    if (regexRule.test(value)) {
      return true;
    }

    return 'This {_field_} field must match followings: 1) Start with lower case; 2) Allow to contain lower case, digits and underscore; 3) NOT allowed ending with underscore';
  },
});

localize({
  en: {
    fields: {
      email: {
        excluded: 'The email is used',
      },
      mobile: {
        excluded: 'The mobile number is used',
      },
    },
  },
});
